import { combineReducers, configureStore } from "@reduxjs/toolkit";
import userSlice from "./slices/userSlice";
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import categorySlice from "./slices/categorySlice";


const persistConfig = {
    key: 'root',
    storage,
    blacklist: [],
}

const rootReducer = combineReducers({
    users: userSlice,
    categories: categorySlice
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = configureStore({
    reducer: persistedReducer
})
export const persistor = persistStore(store);
export default store;